import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { TransformationSection } from '../components/sales/TransformationSection';
import { SystemSection } from '../components/sales/SystemSection';
import { VolumesSection } from '../components/sales/VolumesSection';
import { InsideSection } from '../components/sales/InsideSection';
import { UseCasesSection } from '../components/sales/UseCasesSection';
import { BonusesSection } from '../components/sales/BonusesSection';
import { LibrarySection } from '../components/sales/LibrarySection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { JourneySection } from '../components/sales/JourneySection';
import { ExperienceSection } from '../components/sales/ExperienceSection';
import { CheckoutSection } from '../components/sales/CheckoutSection';
import { FaqSection } from '../components/sales/FaqSection';
import { FinalCtaSection } from '../components/sales/FinalCtaSection';
import { SiteFooter } from '../components/sales/SiteFooter';
import { StickyMobileCta } from '../components/StickyMobileCta';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-269" data-mp="30tdqv54x8m3b">
      <header className="border-b border-brand-charcoal/10 bg-brand-ivory" data-id="element-270" data-mp="2vvln9duwzbja">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-3 lg:px-8" data-id="element-271" data-mp="3tica65ks5ua7">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-272" data-mp="3ojhq70b2tzoi">
            Makeup Instructor <span className="text-brand-berry" data-id="element-273" data-mp="3jjmzawraxa3g">Ready</span>
          </p>
        </div>
      </header>

      <main data-id="element-274" data-mp="3fjl1iyoot0tg">
        <HeroSection data-id="element-275" data-mp="3fi1jb2jh0fp1" />
        <ProblemSection data-id="element-276" data-mp="3fijjubd61g2r" />
        <TransformationSection data-id="element-277" data-mp="2859jmf6pc0yi" />
        <SystemSection data-id="element-278" data-mp="285htdy7j2q5h" />
        <VolumesSection data-id="element-279" data-mp="286sxjz4vxzx4" />
        <InsideSection data-id="element-280" data-mp="282wrj978ca7q" />
        <UseCasesSection data-id="element-281" data-mp="243wek7bfo1sn" />
        <BonusesSection data-id="element-282" data-mp="242l5pt34s3uo" />
        <LibrarySection data-id="element-283" data-mp="242ct82ax70k0" />
        <AudienceSection data-id="element-284" data-mp="25ktnqedhft9m" />
        <JourneySection data-id="element-285" data-mp="25ka1ilgsuips" />
        <ExperienceSection data-id="element-286" data-mp="25m4p67jggoxk" />
        <CheckoutSection data-id="element-287" data-mp="25iqmey6vqdpl" />
        <FaqSection data-id="element-288" data-mp="2ajmrhf2yw5wl" />
        <FinalCtaSection data-id="element-289" data-mp="2ak6a6y0fyybo" />
      </main>

      <SiteFooter data-id="element-290" data-mp="2aj4vmjk7vtp7" />
      <StickyMobileCta data-id="element-291" data-mp="2ahjzipi982p8" />
    </div>;
}